import {useMutation} from "@tanstack/react-query";
import {updateAccountAddressInfo} from "../../../../../api/correspondent/CorresspondentApi";
import {CreateAddress} from "../interface";
// 내부수정: 주소 수정 추가
export const useUpdateAccountAddressInfo = () => {
    const {mutate, mutateAsync} = useMutation({
        mutationFn: (data: CreateAddress) => updateAccountAddressInfo(data),
        onError: (error) => {
            console.log("update error", error);
        },
    });
    return {mutate, mutateAsync};
};